import React from "react";
import Products from "../modules/Products/Products";

export default function ProductsPage() {
  return <Products />;
}
